// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-input {
  background-color: white;
  color: rgb(155, 155, 155);
  box-sizing: border-box;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  box-shadow: none;
  transition: box-shadow 450ms cubic-bezier(0.23, 1, 0.32, 1), right 450ms cubic-bezier(0.23, 1, 0.32, 1);
  z-index: 0;
  overflow: hidden;
  height: 32px;
  position: relative;
  width: 100%;
}

.search-input.active {
  box-shadow: rgba(0, 0, 0, 0.16) 0 3px 6px, rgba(0, 0, 0, 0.23) 0 3px 6px;
}

.search-input input {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  font-size: 16px;
  line-height: 32px;
  margin: 0px;
  padding: 0px 10px 0px 32px;
  border: none;
  outline: none;
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0);
}

.search-input input.disabled {
  cursor: not-allowed;
}

.search-input input.has-value {
  padding-right: 28px;
}

.search-input-cancel {
  position: absolute;
  right: 5px;
  top: 55%;
  transform: translateY(-50%);
  cursor: pointer;
}

.search-input ion-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchInput.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uGAAuG;EACvG,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB","sourcesContent":[".search-input {\n  background-color: white;\n  color: rgb(155, 155, 155);\n  box-sizing: border-box;\n  border-radius: 5px;\n  text-align: center;\n  font-size: 16px;\n  box-shadow: none;\n  transition: box-shadow 450ms cubic-bezier(0.23, 1, 0.32, 1), right 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  z-index: 0;\n  overflow: hidden;\n  height: 32px;\n  position: relative;\n  width: 100%;\n}\n\n.search-input.active {\n  box-shadow: rgba(0, 0, 0, 0.16) 0 3px 6px, rgba(0, 0, 0, 0.23) 0 3px 6px;\n}\n\n.search-input input {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 32px;\n  font-size: 16px;\n  line-height: 32px;\n  margin: 0px;\n  padding: 0px 10px 0px 32px;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.search-input input.disabled {\n  cursor: not-allowed;\n}\n\n.search-input input.has-value {\n  padding-right: 28px;\n}\n\n.search-input-cancel {\n  position: absolute;\n  right: 5px;\n  top: 55%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.search-input ion-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
